import global from 'window-or-global';

export const openLinkNewTab = (href: string) => {
    const link = document.createElement('a');
    link.href = href;
    link.target = '_blank';
    link.id = 'dibsFundLink';
    //@ts-ignore
    document.getElementById('root').appendChild(link);
    link.click();
    link.remove();
};

export const getHost = (): string => {
    const g = global as Window;
    return g.location ? g.location.host : '';
};

export const getScrollTop = () => {
    return window.pageYOffset !== undefined
        ? window.pageYOffset
        : (
              document.documentElement ||
              document.body.parentNode ||
              document.body
          ).scrollTop;
};

export const getDocumentHeight = () => {
    const body = document.body;
    const html = document.documentElement;

    return Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
    );
};

export const inIframe = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};

export const scrollToTop = (settings = {}) => {
    window.scrollTo({
        top: 0,
        ...settings,
    });
};
